import { createAsyncActionTypes } from '../../helpers';

const domain = 'projects';

const fetchProjectById = createAsyncActionTypes(domain, 'fetchProjectById');
const createProject = createAsyncActionTypes(domain, 'createProject');
const editProjectWithRelatedData = createAsyncActionTypes(domain, 'editProjectWithRelatedData');
const deleteProjectById = createAsyncActionTypes(domain, 'deleteProjectById');
const toggleProjectArchivingById = createAsyncActionTypes(domain, 'toggleProjectArchivingById');
const fetchChaptersAndResourcesByProjectId = createAsyncActionTypes(domain, 'fetchChaptersAndResourcesByProjectId');
const getBookSampleAndResourcesByProjectId = createAsyncActionTypes(domain, 'getBookSampleAndResourcesByProjectId');
const fetchChaptersAndResourcesByUser = createAsyncActionTypes(domain, 'fetchChaptersAndResourcesByUser');
const getBookSampleAndResourcesByUser = createAsyncActionTypes(domain, 'getBookSampleAndResourcesByUser');
const fetchDataToCreateProject = createAsyncActionTypes(domain, 'fetchDataToCreateProject');
const fetchDataToEditProject = createAsyncActionTypes(domain, 'fetchDataToEditProject');
const fetchProjectOverviewDataByProjectId = createAsyncActionTypes(domain, 'fetchProjectOverviewDataByProjectId');
const fetchProjectOverviewDataByCustomerId = createAsyncActionTypes(domain, 'fetchProjectOverviewDataByCustomerId');
const addWriterToProject = createAsyncActionTypes(domain, 'addWriterToProject');
const getDataForProjectsList = createAsyncActionTypes(domain, 'getDataForProjectsList');
const moveToNextStageOfProject = createAsyncActionTypes(domain, 'moveToNextStageOfProject');
const fetchTimelineDataByCustomer = createAsyncActionTypes(domain, 'fetchTimelineDataByCustomer');
const toggleUserEnableToEditDraft = createAsyncActionTypes(domain, 'toggleUserEnableToEditDraft');
const toggleUserEnableToEditOutline = createAsyncActionTypes(domain, 'toggleUserEnableToEditOutline');
const toggleUserEnableToDownloadOutline = createAsyncActionTypes(domain, 'toggleUserEnableToDownloadOutline');
const getProjectsDataForExcel = createAsyncActionTypes(domain, 'getProjectsDataForExcel');
const customerReviewedUpgrades = createAsyncActionTypes(domain, 'customerReviewedUpgrades');
const getDataFromHubspot = createAsyncActionTypes(domain, 'getDataFromHubspot');
const editorSeenRequestForUpgrade = createAsyncActionTypes(domain, 'editorSeenRequestForUpgrade');
const getProjectAndBookData = createAsyncActionTypes(domain, 'getProjectAndBookData');
const cancelUpgradeRequest = createAsyncActionTypes(domain, 'cancelUpgradeRequest');
const completeUpgradeRequest = createAsyncActionTypes(domain, 'completeUpgradeRequest');
const getNextStageForProject = createAsyncActionTypes(domain, 'getNextStageForProject');

export default {
  fetchProjectOverviewDataByProjectId,
  fetchProjectOverviewDataByCustomerId,
  fetchProjectById,
  createProject,
  editProjectWithRelatedData,
  deleteProjectById,
  toggleProjectArchivingById,
  fetchChaptersAndResourcesByProjectId,
  fetchChaptersAndResourcesByUser,
  fetchDataToCreateProject,
  fetchDataToEditProject,
  getDataForProjectsList,
  addWriterToProject,
  moveToNextStageOfProject,
  fetchTimelineDataByCustomer,
  toggleUserEnableToEditDraft,
  toggleUserEnableToEditOutline,
  toggleUserEnableToDownloadOutline,
  getProjectsDataForExcel,
  customerReviewedUpgrades,
  getDataFromHubspot,
  editorSeenRequestForUpgrade,
  getBookSampleAndResourcesByUser,
  getBookSampleAndResourcesByProjectId,
  getProjectAndBookData,
  cancelUpgradeRequest,
  completeUpgradeRequest,
  getNextStageForProject,
};
